import { lazy } from 'react';

export const FeedPage = lazy(() => import('./controller.js'));
